var React = require('react');

function CircleSmallPartStroke (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","d":"M14.729,87.975h73.243V14.73C49.174,18.175,18.175,49.173,14.729,87.975z","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M0,95.18c0,3.979,3.227,7.205,7.205,7.205h87.974c3.979,0,7.205-3.227,7.205-7.205V7.206\r\n\t\tc0-3.979-3.227-7.206-7.205-7.206c-6.945,0-13.715,0.755-20.24,2.174c-8.107,2.032-14.412,4.357-14.412,4.357\r\n\t\tC25.13,20.416,0,54.918,0,95.18z M87.972,14.73v73.244H14.729C18.175,49.173,49.174,18.175,87.972,14.73z","key":1})]));
}

CircleSmallPartStroke.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"102.384px","height":"102.385px","viewBox":"0 0 102.384 102.385","enableBackground":"new 0 0 102.384 102.385","xmlSpace":"preserve"};

module.exports = CircleSmallPartStroke;

CircleSmallPartStroke.default = CircleSmallPartStroke;
